<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
    style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='带教老师月度绩效考评' label2="修改评分" label3="tips：1.填写评分内容后保存。2.下载凭证。3.上传签字凭证。4.提交。"
        url="/achievement/teach/scorerecordlist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form"
        ref="form">
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <div style="width: 100%;overflow: auto;">
            <el-table ref="scoretable" v-if="ScoreType == '0' || ScoreType == '3'" :data="form.tableData" height="500"
              stripe border
              :header-cell-style="{ 'color': '#000000', 'background': '#F7F8FA', 'text-align': 'center', 'height': '200px' }">
              <el-table-column :label="this.form.cpidate" width="150" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.row.CPIDName }}({{ scope.row.CPIDNo }})</span>
                  <br><span>{{ scope.row.CPIDSecName }}</span>
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  带教<br>学员<br>有无<br>入科<br>教育
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent1" @change="SelectChange(scope.row, 1, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="有" value="有"></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 1, '') }}
                  <!-- {{scope.row.CPIDScore1}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>完成<br>形成性<br>评价
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent2" @change="SelectChange(scope.row, 2, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 2, '') }}
                  <!-- 	{{scope.row.CPIDScore2}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  带教<br>学员<br>是否<br>完成<br>出科<br>考核
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent3" @change="SelectChange(scope.row, 3, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore3 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>小讲课<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent4" @change="SelectChange(scope.row, 4, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 4, '') }}
                  <!-- {{scope.row.CPIDScore4}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>教育<br>查房<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent5" @change="SelectChange(scope.row, 5, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 5, '') }}
                  <!-- 	{{scope.row.CPIDScore5}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  教育<br>查房<br>质量<br>考核<br>评分<br>分数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent6" @change="SelectChange(scope.row, 6, '教育查房质量考核评分分数')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore6 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>教学<br>病例<br>讨论<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent7" @change="SelectChange(scope.row, 7, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 7, '') }}
                  <!-- {{scope.row.CPIDScore7}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  手写<br>病历<br>批改<br>指导<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent8" @change="SelectChange(scope.row, 8, '专业报告判读指导情况')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore8 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  读书<br>心得<br>批改<br>指导<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent9" @change="SelectChange(scope.row, 9, '读书心得批改指导情况')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore9 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>在线<br>审核<br>APP<br>填写<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent10" @change="SelectChange(scope.row, 10, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore10 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>有学<br>员不<br>良反<br>馈
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent11" @change="SelectChange(scope.row, 11, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="有" value="有"></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore11 }}
                </template>
              </el-table-column>
              <el-table-column label="总分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore = scope.row.CPIDScore1 * 1 + scope.row.CPIDScore2 * 1 + scope.row.CPIDScore3 *
        1 + scope.row.CPIDScore4 * 1 + scope.row.CPIDScore5 * 1 + scope.row.CPIDScore6 * 1 +
        scope.row.CPIDScore7 * 1 + scope.row.CPIDScore8 * 1 + scope.row.CPIDScore9 * 1 + scope.row.CPIDScore10
        * 1 + scope.row.CPIDScore11 * 1 }}
                </template>
              </el-table-column>
            </el-table>
            <el-table ref="scoretable" v-if="ScoreType == '1'" :data="form.tableData" height="500" stripe border
              :header-cell-style="{ 'color': '#000000', 'background': '#F7F8FA', 'text-align': 'center', 'height': '200px' }">
              <el-table-column :label="this.form.cpidate" width="150" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.row.CPIDName }}({{ scope.row.CPIDNo }})</span>
                  <br><span>{{ scope.row.CPIDSecName }}</span>
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  带教<br>学员<br>有无<br>入科<br>教育
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent1" @change="SelectChange(scope.row, 1, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="有" value="有"></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 1, '') }}
                  <!-- {{scope.row.CPIDScore1}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>完成<br>形成性<br>评价
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent2" @change="SelectChange(scope.row, 2, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 2, '') }}
                  <!-- 	{{scope.row.CPIDScore2}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  带教<br>学员<br>是否<br>完成<br>出科<br>考核
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent3" @change="SelectChange(scope.row, 3, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore3 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>小讲课<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent4" @change="SelectChange(scope.row, 4, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 4, '') }}
                  <!-- {{scope.row.CPIDScore4}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>教学<br>查房<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent5" @change="SelectChange(scope.row, 5, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 5, '') }}
                  <!-- 	{{scope.row.CPIDScore5}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  教育<br>查房<br>质量<br>考核<br>评分<br>分数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent6" @change="SelectChange(scope.row, 6, '教育查房质量考核评分分数')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore6 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>教学<br>病例<br>讨论<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent7" @change="SelectChange(scope.row, 7, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 7, '') }}
                  <!-- {{scope.row.CPIDScore7}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  麻醉<br>前访<br>视及<br>计划<br>指导<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent8" @change="SelectChange(scope.row, 8, '麻醉前访视及计划指导情况')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore8 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  读书<br>心得<br>批改<br>指导<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent9" @change="SelectChange(scope.row, 9, '读书心得批改指导情况')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore9 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>在线<br>审核<br>APP<br>填写<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent10" @change="SelectChange(scope.row, 10, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore10 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>有学<br>员不<br>良反<br>馈
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent11" @change="SelectChange(scope.row, 11, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="有" value="有"></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore11 }}
                </template>
              </el-table-column>
              <el-table-column label="总分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore = scope.row.CPIDScore1 * 1 + scope.row.CPIDScore2 * 1 + scope.row.CPIDScore3 *
        1 + scope.row.CPIDScore4 * 1 + scope.row.CPIDScore5 * 1 + scope.row.CPIDScore6 * 1 +
        scope.row.CPIDScore7 * 1 + scope.row.CPIDScore8 * 1 + scope.row.CPIDScore9 * 1 + scope.row.CPIDScore10
        * 1 + scope.row.CPIDScore11 * 1 }}
                </template>
              </el-table-column>
            </el-table>
            <el-table ref="scoretable" v-if="ScoreType == '2'" :data="form.tableData" height="500" stripe border
              :header-cell-style="{ 'color': '#000000', 'background': '#F7F8FA', 'text-align': 'center', 'height': '200px' }">
              <el-table-column :label="this.form.cpidate" width="150" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.row.CPIDName }}({{ scope.row.CPIDNo }})</span>
                  <br><span>{{ scope.row.CPIDSecName }}</span>
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  带教<br>学员<br>有无<br>入科<br>教育
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent1" @change="SelectChange(scope.row, 1, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="有" value="有"></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 1, '') }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>完成<br>形成性<br>评价
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent2" @change="SelectChange(scope.row, 2, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 2, '') }}
                  <!-- {{scope.row.CPIDScore2}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  带教<br>学员<br>是否<br>完成<br>出科<br>考核
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent3" @change="SelectChange(scope.row, 3, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore3 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>小讲课<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent4" @change="SelectChange(scope.row, 4, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 4, '') }}
                  <!-- 	{{scope.row.CPIDScore4}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>教学<br>查房<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent5" @change="SelectChange(scope.row, 5, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 5, '') }}
                  <!-- {{scope.row.CPIDScore5}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  教育<br>查房<br>质量<br>考核<br>评分<br>分数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent6" @change="SelectChange(scope.row, 6, '教育查房质量考核评分分数')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore6 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  组织<br>教学<br>病例<br>讨论<br>次数
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent7" @change="SelectChange(scope.row, 7, '')"
                    :disabled="isDisabled">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="≥4" value="≥4"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ getNumber(scope.row, 7, '') }}
                  <!-- {{scope.row.CPIDScore7}} -->
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  专业<br>报告<br>判读<br>指导<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent8" @change="SelectChange(scope.row, 8, '专业报告判读指导情况')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore8 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  读书<br>心得<br>批改<br>指导<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent9" @change="SelectChange(scope.row, 9, '读书心得批改指导情况')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="优秀" value="优秀"></el-option>
                    <el-option label="良好" value="良好"></el-option>
                    <el-option label="一般" value="一般"></el-option>
                    <el-option label="较差" value="较差"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore9 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>在线<br>审核<br>APP<br>填写<br>情况
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent10" @change="SelectChange(scope.row, 10, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore10 }}
                </template>
              </el-table-column>
              <el-table-column width="150">
                <template slot="header">
                  是否<br>有学<br>员不<br>良反<br>馈
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.CPIDContent11" @change="SelectChange(scope.row, 11, '')">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="有" value="有"></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="得分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore11 }}
                </template>
              </el-table-column>
              <el-table-column label="总分" width="100">
                <template slot-scope="scope">
                  {{ scope.row.CPIDScore = scope.row.CPIDScore1 * 1 + scope.row.CPIDScore2 * 1 + scope.row.CPIDScore3 *
        1 + scope.row.CPIDScore4 * 1 + scope.row.CPIDScore5 * 1 + scope.row.CPIDScore6 * 1 +
        scope.row.CPIDScore7 * 1 + scope.row.CPIDScore8 * 1 + scope.row.CPIDScore9 * 1 + scope.row.CPIDScore10
        * 1 + scope.row.CPIDScore11 * 1 }}
                </template>
              </el-table-column>
            </el-table>
            <div style="margin: 15px;">
              <div style="font-size: 18px;">优秀评分理由填写</div>
              <el-table :data="form.remarkTable">
                <el-table-column prop="StuName" label="带教老师" width="150">
                </el-table-column>
                <el-table-column prop="StuNo" label="工号" width="150">
                </el-table-column>
                <el-table-column prop="ETDContent" label="评分项" width="200">
                </el-table-column>
                <el-table-column label="理由">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.ContentRemark"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">签字凭证：</label>
            <div class="col-xl-4">
              <el-upload class="upload-demo" ref="upload" action="#" list-type="picture" :auto-upload="false">
                <el-button slot="trigger" size="medium" type="primary">选取文件</el-button>
                <el-button style="margin-left: 10px;" size="medium" type="success" @click="submitFile"><i
                    class="el-icon-upload el-icon--right"></i>上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传 jpg/png 文件</div>
              </el-upload>
            </div>
          </div>
          <div class="form-group m-form__group row" v-if="tableFileData.length != 0">
            <div class="col-xl-2">
            </div>
            <div class="col-xl-10">
              <el-table v-loading="loading" :data="tableFileData" stripe style="width: 100%" size="medium">
                <el-table-column label="附件名">
                  <template slot-scope="scope">
                    {{ scope.row.FileName }}<span style="color: #409EFF;cursor: pointer;padding-left: 10px;"
                      @click="See(scope.row)">[查看]</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button @click="DeleteFile(scope.row)" type="text" size="medium"
                      style="color: red;">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
          <div class="m-form__actions m-form__actions--solid">
            <div class="row">
              <div class="col-lg-12 m--align-center">
                <el-button type="success" icon="el-icon-s-order" @click="Edit"
                  v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
                <el-button type="primary" icon="el-icon-download" @click="DownFile" plain>下载凭证</el-button>
                <el-button type="primary" icon="el-icon-s-order" @click="Save"
                  v-loading.fullscreen.lock="fullscreenLoading">提交</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="凭证查看" :visible.sync="dialogImgVisible">
      <el-image style="width: 100%;" :src="imgurl"></el-image>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TecScoreEdit',
  data() {
    return {
      form: {
        token: '',
        id: '',
        cpitype: 2,
        cpistatus: 1,
        tableData: [],
        cpifile: '',
        cpifiledesc: '',
        sec: '',
        remarkTable: []
      },
      tabHead: '',
      index: 0,
      fileList: [],
      fullscreenLoading: false,
      content: [{
        value: '带教学员有无入科教育'
      }, {
        value: '是否严格考勤'
      }, {
        value: '带教学员是否完成出科考核'
      }, {
        value: '组织小讲座次数'
      }, {
        value: '组织教育查房次数'
      }, {
        value: '教育查房质量考核评分分数'
      }, {
        value: '组织疑难病例讨论次数'
      }, {
        value: '手写病历批改指导情况'
      }, {
        value: '读书心得批改指导情况'
      }, {
        value: '是否在线审核APP填写情况'
      }, {
        value: '是否有学员不良反应'
      }],
      content1: [{
        value: '带教学员有无入科教育'
      }, {
        value: '是否严格考勤'
      }, {
        value: '带教学员是否完成出科考核'
      }, {
        value: '组织小讲座次数'
      }, {
        value: '组织教育查房次数'
      }, {
        value: '教育查房质量考核评分分数'
      }, {
        value: '组织疑难病例讨论次数'
      }, {
        value: '专业报告判读指导情况'
      }, {
        value: '读书心得批改指导情况'
      }, {
        value: '是否在线审核APP填写情况'
      }, {
        value: '是否有学员不良反应'
      }],
      content2: [{
        value: '带教学员有无入科教育'
      }, {
        value: '是否严格考勤'
      }, {
        value: '带教学员是否完成出科考核'
      }, {
        value: '组织小讲座次数'
      }, {
        value: '组织教育查房次数'
      }, {
        value: '教育查房质量考核评分分数'
      }, {
        value: '组织疑难病例讨论次数'
      }, {
        value: '麻醉前访视及计划指导情况'
      }, {
        value: '读书心得批改指导情况'
      }, {
        value: '是否在线审核APP填写情况'
      }, {
        value: '是否有学员不良反应'
      }],
      record: {
        ManageSecName: '',
        Month: '',
      },
      tableFileData: [],
      FileGuid: '',
      dialogImgVisible: false,
      imgurl: '',
      ScoreType: '0',
      isDisabled: true
    }
  },
  computed: {
    getNumber() {
      let that = this
      return function (row, index, title) {
        that.SelectChange(row, index, title)
        return row['CPIDScore' + [index]]
      }
    },
  },
  methods: {
    SelectChange: function (row, index, title) {
      if (index == 1) {
        if (row.CPIDContent1 == "有") {
          row.CPIDScore1 = 5
        } else if (row.CPIDContent1 == "无") {
          row.CPIDScore1 = 0
        } else {
          row.CPIDScore1 = 0
        }
      } else if (index == 2) {
        if (row.CPIDContent2 == "是") {
          row.CPIDScore2 = 10
        } else if (row.CPIDContent2 == "否") {
          row.CPIDScore2 = 0
        } else {
          row.CPIDScore2 = 0
        }
      } else if (index == 3) {
        if (row.CPIDContent3 == "是") {
          row.CPIDScore3 = 10
        } else if (row.CPIDContent3 == "否") {
          row.CPIDScore3 = 0
        } else {
          row.CPIDScore3 = 0
        }
      } else if (index == 4) {
        if (row.CPIDContent4 == "0") {
          row.CPIDScore4 = 0
        } else if (row.CPIDContent4 == "1") {
          row.CPIDScore4 = 5
        } else if (row.CPIDContent4 == "2") {
          row.CPIDScore4 = 10
        } else if (row.CPIDContent4 == "3") {
          row.CPIDScore4 = 10
        } else if (row.CPIDContent4 == "≥4") {
          row.CPIDScore4 = 10
        } else {
          row.CPIDScore4 = 0
        }
      } else if (index == 5) {
        if (row.CPIDContent5 == "0") {
          row.CPIDScore5 = 0
        } else if (row.CPIDContent5 == "1") {
          row.CPIDScore5 = 5
        } else if (row.CPIDContent5 == "2") {
          row.CPIDScore5 = 10
        } else if (row.CPIDContent5 == "3") {
          row.CPIDScore5 = 10
        } else if (row.CPIDContent5 == "≥4") {
          row.CPIDScore5 = 10
        } else {
          row.CPIDScore5 = 0
        }
      } else if (index == 6) {
        if (row.CPIDContent6 == "优秀") {
          row.CPIDScore6 = 10
        } else if (row.CPIDContent6 == "良好") {
          row.CPIDScore6 = 10
        } else if (row.CPIDContent6 == "一般") {
          row.CPIDScore6 = 5
        } else if (row.CPIDContent6 == "较差") {
          row.CPIDScore6 = 0
        } else {
          row.CPIDScore6 = 0
        }

        if (row.CPIDContent6 == "优秀") {
          let arg = {
            CPIID: '',
            StuID: row.CPIDPersonID,
            StuName: row.CPIDName,
            StuNo: row.CPIDNo,
            ETDContent: title,
            ContentRemark: ''
          }

          this.form.remarkTable.push(arg)
        } else {
          let objs = this.form.remarkTable
          let newobj = objs.reduce((total, current) => {
            if (current.StuID != row.CPIDPersonID) {
              total.push(current)
            } else {
              if (current.ETDContent != title) {
                total.push(current)
              }
            }
            return total
          }, []);

          this.form.remarkTable = newobj
        }

      } else if (index == 7) {
        if (row.CPIDContent7 == "0") {
          row.CPIDScore7 = 0
        } else if (row.CPIDContent7 == "1") {
          row.CPIDScore7 = 5
        } else if (row.CPIDContent7 == "2") {
          row.CPIDScore7 = 10
        } else if (row.CPIDContent7 == "3") {
          row.CPIDScore7 = 10
        } else if (row.CPIDContent7 == "≥4") {
          row.CPIDScore7 = 10
        } else {
          row.CPIDScore7 = 0
        }
      } else if (index == 8) {
        if (row.CPIDContent8 == "优秀") {
          row.CPIDScore8 = 10
        } else if (row.CPIDContent8 == "良好") {
          row.CPIDScore8 = 10
        } else if (row.CPIDContent8 == "一般") {
          row.CPIDScore8 = 5
        } else if (row.CPIDContent8 == "较差") {
          row.CPIDScore8 = 0
        } else {
          row.CPIDScore8 = 0
        }

        if (row.CPIDContent8 == "优秀") {
          let arg = {
            StuID: row.CPIDPersonID,
            StuName: row.CPIDName,
            StuNo: row.CPIDNo,
            ETDContent: title,
            ContentRemark: ''
          }

          this.form.remarkTable.push(arg)
        } else {
          let objs = this.form.remarkTable
          let newobj = objs.reduce((total, current) => {
            if (current.StuID != row.CPIDPersonID) {
              total.push(current)
            } else {
              if (current.ETDContent != title) {
                total.push(current)
              }
            }
            return total
          }, []);

          this.form.remarkTable = newobj
        }
      } else if (index == 9) {
        if (row.CPIDContent9 == "优秀") {
          row.CPIDScore9 = 10
        } else if (row.CPIDContent9 == "良好") {
          row.CPIDScore9 = 10
        } else if (row.CPIDContent9 == "一般") {
          row.CPIDScore9 = 5
        } else if (row.CPIDContent9 == "较差") {
          row.CPIDScore9 = 0
        } else {
          row.CPIDScore9 = 0
        }

        if (row.CPIDContent9 == "优秀") {
          let arg = {
            StuID: row.CPIDPersonID,
            StuName: row.CPIDName,
            StuNo: row.CPIDNo,
            ETDContent: title,
            ContentRemark: ''
          }

          this.form.remarkTable.push(arg)
        } else {
          let objs = this.form.remarkTable
          let newobj = objs.reduce((total, current) => {
            if (current.StuID != row.CPIDPersonID) {
              total.push(current)
            } else {
              if (current.ETDContent != title) {
                total.push(current)
              }
            }
            return total
          }, []);

          this.form.remarkTable = newobj
        }
      } else if (index == 10) {
        if (row.CPIDContent10 == "是") {
          row.CPIDScore10 = 5
        } else if (row.CPIDContent10 == "否") {
          row.CPIDScore10 = 0
        } else {
          row.CPIDScore10 = 0
        }
      } else {
        if (row.CPIDContent11 == "有") {
          row.CPIDScore11 = 0
        } else if (row.CPIDContent11 == "无") {
          row.CPIDScore11 = 10
        } else {
          row.CPIDScore11 = 0
        }
      }
    },
    DeleteFile: function (row) {
      this.$confirm('确定删除凭证附件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var args = {
          id: row.ID,
          token: this.form.token
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/DeleteFile', args)
          .then(res => {
            console.log(res.data)
            if (res.data.Code === 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.LoadFileList()
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '删除失败',
              type: 'error'
            })
          })
      }).catch(() => { })
    },
    See: function (row) {
      this.imgurl = this.$utils.Url.zpgl + '/file/' + row.FileName
      this.dialogImgVisible = true
    },
    LoadFileList: function () {
      this.loading = true
      var args = {
        token: this.form.token,
        guid: this.FileGuid
      }
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/FileListByGuid', args)
        .then(res => {
          if (res.data.Code === 0) {
            this.tableFileData = res.data.Data
            if (this.tableFileData.length == 0) {
              this.FileState = false
            }
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
          this.loading = false
        })
        .catch(err => {
          this.tableData = null
          console.log(err)
          this.$message({
            message: '查询失败',
            type: 'error'
          })
          this.loading = false
        })
    },
    DownFile: function () {
      var args = {
        token: this.form.token,
        id: this.form.id
      }
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/DownTecFile', args)
        .then(res => {
          if (res.data.Code === 0) {
            var filename = res.data.Data
            var url = this.$utils.Url.zpgl + '/pdf/' + filename
            window.open(url)
          } else {
            this.$message({
              message: res.data.Data,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '下载失败',
            type: 'error'
          })
        })
    },
    submitFile: function () {
      let formData = new FormData()
      let {
        uploadFiles
      } = this.$refs.upload
      uploadFiles.forEach(function (item) {
        // 因为要上传多个文件，所以需要遍历
        formData.append('file', item.raw)
      })
      formData.append('id', this.form.id)
      var that = this
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/UploadFile', formData, {
        'Content-Type': 'multipart/form-data'
      })
        .then(res => {
          console.log(res.data)
          if (res.data.Code === 0) {
            that.$message({
              message: '上传成功',
              type: 'success'
            })
            that.$refs.upload.clearFiles()
            that.FileGuid = res.data.Data
            that.FileState = true
            that.LoadFileList()
          } else {
            that.$message({
              message: res.data.Msg + '，' + res.data.Data,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '上传失败',
            type: 'error'
          })
        })
    },
    Save: function () {
      this.fullscreenLoading = true
      for (let i = 0; i < this.form.tableData.length; i++) {
        let stuname = this.form.tableData[i].CPIDName
        for (let j = 1; j <= 11; j++) {
          if (this.form.tableData[i]["CPIDContent" + j] === null || this.form.tableData[i]["CPIDContent" + j] ===
            '') {
            let contenttitle = ''
            if (this.ScoreType == '0') {
              contenttitle = this.content[j - 1].value
            } else if (this.ScoreType == '1') {
              contenttitle = this.content1[j - 1].value
            } else if (this.ScoreType == '2') {
              contenttitle = this.content2[j - 1].value
            }
            let message = "带教老师 " + stuname + " 的 " + contenttitle + " 未填写"
            this.$alert(message, '警告', {
              confirmButtonText: '确定'
            })
            this.fullscreenLoading = false
            return
          }
        }
      }

      for (let i = 0; i < this.form.remarkTable.length; i++) {
        if (this.form.remarkTable[i]["ContentRemark"] === null || this.form.remarkTable[i]["ContentRemark"] ===
          '') {
          let stuname = this.form.remarkTable[i]["StuName"]
          let contenttitle = this.form.remarkTable[i]["ETDContent"]
          let message = "带教老师 " + stuname + " 的 " + contenttitle + " 的 优秀评分理由 未填写"
          this.$alert(message, '警告', {
            confirmButtonText: '确定'
          })
          this.fullscreenLoading = false
          return
        }
      }

      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/SaveCPI', this.form)
        .then(res => {
          if (res.data.Code === 0) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.fullscreenLoading = false
            this.$router.push('/main/achievement/teach/scorerecordlist')
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
            this.fullscreenLoading = false
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '提交失败',
            type: 'error'
          })
          this.fullscreenLoading = false
        })
    },
    Edit: function () {
      this.fullscreenLoading = true
      if (this.ScoreType == "3") {
        for (var i = 0; i < this.form.tableData.length; i++) {
          var stuname = this.form.tableData[i].CPIDName
          for (var j = 1; j <= 11; j++) {
            if (this.form.tableData[i]["CPIDContent" + j] === null || this.form.tableData[i]["CPIDContent" + j] ===
              '') {
              let message = "带教老师 " + stuname + " 的 " + this.content[j - 1].value + " 未填写"
              this.$alert(message, '警告', {
                confirmButtonText: '确定'
              })
              this.fullscreenLoading = false
              return
            }

            if (this.form.tableData[i]["CPIDScore" + j] === null || this.form.tableData[i]["CPIDScore" + j] ===
              '') {
              let message = "带教老师 " + stuname + " 的 " + this.content[j - 1].value + " 的 得分 未填写"
              this.$alert(message, '警告', {
                confirmButtonText: '确定'
              })
              this.fullscreenLoading = false
              return
            }
          }
        }

        for (let i = 0; i < this.form.remarkTable.length; i++) {
          if (this.form.remarkTable[i]["ContentRemark"] === null || this.form.remarkTable[i]["ContentRemark"] ===
            '') {
            let stuname = this.form.remarkTable[i]["StuName"]
            let contenttitle = this.form.remarkTable[i]["ETDContent"]
            let message = "带教老师 " + stuname + " 的 " + contenttitle + " 的 优秀评分理由 未填写"
            this.$alert(message, '警告', {
              confirmButtonText: '确定'
            })
            this.fullscreenLoading = false
            return
          }
        }
      }

      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/Update', this.form)
        .then(res => {
          console.log(res.data)
          if (res.data.Code === 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            console.log('保存成功')
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
          this.fullscreenLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '保存失败',
            type: 'error'
          })
          this.fullscreenLoading = false
        })
    },
    LoadCPI: function () {
      var that = this
      this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICPI/Info', this.form, function (data, model) {
        model.cpitype = data.Data.CPIType
        model.cpistatus = data.Data.CPIStatus
        model.cpifile = data.Data.CPIFile
        model.cpifiledesc = data.Data.CPIFileDesc
        if (data.Data.CPIRemark4 != null && data.Data.CPIRemark4 != '') {
          that.FileGuid = data.Data.CPIRemark4
          that.FileState = true
          that.LoadFileList()
        }
        var date = new Date(data.Data.CPIDate)
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        if (month > 12) {
          year = year + 1
          month = 1
        }
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        model.cpidate = year + '-' + month
        that.record.Month = year + '年' + month + '月'

        that.LoadScoreType()
      }, null, null, this.form)
    },
    LoadScoreType: function () {
      this.loading = true
      var that = this
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/GetScoreTypeBySec', this.form)
        .then(res => {
          if (res.data.Code === 0) {
            that.ScoreType = res.data.Data
            that.LoadScoreTeach()
          } else {
            that.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
          that.loading = false
        })
        .catch(err => {
          console.log(err)
          that.$message({
            message: '查询失败',
            type: 'error'
          })
          that.loading = false
        })
    },
    LoadScoreTeach: function () {
      var that = this
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/ScoreTeach', this.form)
        .then(res => {
          if (res.data.Code === 0) {
            that.form.tableData = res.data.Data
            that.index = res.data.Pager.RecordCount
            that.$nextTick(() => {
              that.$refs.scoretable.doLayout();
            })
            that.LoadCPIRemark()
          } else {
            that.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          that.form.tableData = null
          that.index = 0
          console.log(err)
          that.$message({
            message: '查询失败',
            type: 'error'
          })
        })
    },
    LoadCPIRemark: function () {
      var that = this
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/GetCPIRemark', this.form)
        .then(res => {
          if (res.data.Code === 0) {
            that.form.remarkTable = res.data.Data
          } else {
            that.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          that.form.remarkTable = []
          console.log(err)
          that.$message({
            message: '查询失败',
            type: 'error'
          })
        })
    }
  },
  mounted: function () {
    this.form.token = sessionStorage.getItem('token')
    this.form.sec = sessionStorage.getItem('secid')
    this.form.id = this.$route.params.id
    if(sessionStorage.getItem('manageid') == 4236){
                this.isDisabled=false
            }
    this.LoadCPI()
  }
}
</script>
<style scoped="scoped">
.m-form.m-form--group-seperator-dashed .m-form__group {
  border-bottom: 0;
}

::v-deep .el-table__header-wrapper {
  width: 100%;
}
</style>

<style scoped="scoped">
@import '../../../assets/css/tecscore.css'
</style>


